import { useEffect } from 'react'
import { RadioGroup } from 'entities/RadioGroup'
import { useConfigStore } from 'shared/store/configSlice'
import { useGlobalStore } from 'shared/store/globalSlice'
import { getAppName } from 'shared/helpers/getAppName'
import { productViewOptions } from './options'

export const ProductsLayout = () => {
  const updateInterface = useConfigStore().updateInterface
  const config = useConfigStore().config
  const isConfigLoaded = useConfigStore().isConfigLoaded
  const isCC = useGlobalStore().isCCSelected
  const productViewType = config?.interfaceConfig?.[getAppName(isCC)]?.productViewType

  useEffect(() => {
    if (!productViewType && isConfigLoaded) {
      updateLayout(productViewOptions?.[0]?.value)
    }
  }, [productViewType, isConfigLoaded])

  const updateLayout = (value: string) => {
    updateInterface({ productViewType: value as 'list' })
  }

  return (
    <RadioGroup
      key={`product_view_${productViewType}`}
      options={productViewOptions}
      //   value={interfaceData?.Font}
      value={productViewType}
      handleChange={updateLayout}
      title='Product Layout'
      sx={{
        width: '720px',
        display: 'grid',
        gap: '10px',
        gridTemplateColumns: 'repeat(auto-fill, 233px)'
      }}
    />
  )
}
